import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';

export function NotFoundPage() {
  return (
    <>
      <SEO
        title="Page Not Found — logNsec"
        description="The page you are looking for could not be found."
        noindex
      />
      <section className="bg-[#F5F5F5] px-5 py-24 text-center md:px-8 md:py-32">
        <div className="mx-auto max-w-xl">
          <p className="text-[64px] font-extrabold leading-none text-[#0064E0]">404</p>
          <h1 className="text-section mt-4">Page Not Found</h1>
          <p className="mx-auto mt-6 max-w-[440px] text-body-site">
            The page you are looking for doesn&apos;t exist or may have moved.
          </p>
          <Link
            to="/"
            className="mt-8 inline-flex rounded-lg bg-[#0064E0] px-8 py-3.5 text-base font-semibold text-white transition-colors hover:bg-[#0056C8]"
          >
            Back to Home
          </Link>
        </div>
      </section>
    </>
  );
}
